/**
 * @fileoverview This enables the play button to appear and disappear when the
 * a video media is paused or playing. This only specifically applies for the
 * 'video.liquid' and 'video-gallery.liquid' sections. But you can add more by
 * adding the class 'VideoMedia' to the parent element. Then add the class
 * 'VideoMedia__PlayButton' to the play button element.
 */

document.addEventListener('DOMContentLoaded', () => {
  const videoMedias = $('.VideoMedia');

  for (let videe of videoMedias) {
    const video = videe.querySelector('video');
    const playButton = videe.querySelector('.VideoMedia__PlayButton');

    // Desktop click event.
    video.addEventListener('click', (event) => {
      event.preventDefault();
      if (video.paused) {
        video.play();
        playButton.style.display = 'none';
      } else {
        playButton.style.display = 'block';
        video.pause();
      }
    });

    // Mobile touch event.
    video.addEventListener('touchstart', (event) => {
      event.preventDefault();
      if (video.paused) {
        video.play();
        playButton.style.display = 'none';
      } else {
        playButton.style.display = 'block';
        video.pause();
      }
    });

    video.addEventListener('pause', (event) => {
      event.preventDefault();
      if (!video.paused) {
        playButton.style.display = 'block';
      }
    });
  }
});
